export default {
  common: {
    login: 'Anmelden',
    logout: 'Abmelden',
    support: 'Kundendienst',
    privacy: 'Datenschutzrichtlinie',
    terms: 'Nutzungsbedingungen',
    and: 'und',
    guest: 'Gast',
    play: 'Spielen',
    install: 'Installieren',
  },
  support: {
    title: 'Brauchst du Hilfe?',
    description: `Wenn du beim Spielen dieses Spiels auf irgendwelche Probleme stößt,
      helfen wir dir gerne weiter und beantworten all deine Fragen.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Hilf Austin dem Butler dabei, Wärme und Komfort zurück in die wunderbare Villa seiner Familie zu bringen.',
    description: `Hilf Austin dem Butler dabei, Wärme und Komfort zurück
      in die wunderbare Villa seiner Familie zu bringen. Komm nur herein – Abenteuer
      erwarten dich bereits auf der Türschwelle!`,
  },
  cookie: {
    message:
      'Diese Webseite verwendet Cookies, um dir das bestmögliche Nutzererlebnis auf unserer Webseite bieten zu können.',
    link: 'Weitere Infos',
    button: 'Annehmen',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes auf deinem Desktop!
    Installiere die Web-Version des Spiels und besuche Austin mit nur wenigen Klicks!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla ist ein authorisierter weltweiter Vertriebspartner von Homescapes',
  },
  game: {
    notSupported: `Mobilgeräte werden nicht unterstützt.
      Melde dich mit deinem Computer an, um zu spielen.`,
  },
};
